import { render, staticRenderFns } from "./DetalheEscola.vue?vue&type=template&id=23fd4835"
import script from "./DetalheEscola.vue?vue&type=script&lang=js"
export * from "./DetalheEscola.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports